module.exports = __webpack_public_path__ + "img/logo.aca7902e.svg";